import { render, staticRenderFns } from "./ProjectOverdue.vue?vue&type=template&id=0dc364e8&"
import script from "./ProjectOverdue.vue?vue&type=script&lang=js&"
export * from "./ProjectOverdue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports